var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageAlert64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconAlert64",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,0 C49.673112,0 64,14.326888 64,32 C63.9798462,49.6647573 49.6647573,63.9798462 32,64 C14.326888,64 0,49.673112 0,32 C0,14.326888 14.326888,0 32,0 Z M32,4.57142857 C16.8516183,4.57142857 4.57142857,16.8516183 4.57142857,32 C4.57142857,47.1483817 16.8516183,59.4285714 32,59.4285714 C47.1483817,59.4285714 59.4285714,47.1483817 59.4285714,32 C59.4121946,16.858407 47.141593,4.58780537 32,4.57142857 Z M31.9702857,42 C34.495016,42 36.5417143,44.0466983 36.5417143,46.5714286 C36.5417143,49.0961589 34.495016,51.1428571 31.9702857,51.1428571 C29.4455554,51.1428571 27.3988571,49.0961589 27.3988571,46.5714286 C27.3988571,44.0466983 29.4455554,42 31.9702857,42 Z M31.9714286,12.7897143 C34.12313,12.7897143 35.8674286,14.5340129 35.8674286,16.6857143 L35.0994286,36.4891429 C35.1700327,37.6617879 34.5845289,38.7768687 33.5791275,39.3845276 C32.5737261,39.9921865 31.3142739,39.9921865 30.3088725,39.3845276 C29.3034711,38.7768687 28.7179673,37.6617879 28.7885714,36.4891429 L28.0754286,16.6857143 C28.0754286,14.5340129 29.8197272,12.7897143 31.9714286,12.7897143 Z",
    id: "Combined-Shape-Copy-3",
    fill: "#C73500"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageAlert64);
export default __webpack_public_path__ + "static/media/messageAlert64.35cdd8450371b43736fec6dbb5d17e28.svg";
export { ForwardRef as ReactComponent };